// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_special_characters
const escapeRegexCharacters = str => str.replace(/[+?^${}()|[\]\\]/g, '\\$&');
export { escapeRegexCharacters };


// WEBPACK FOOTER //
// ./src/components/OrderGuide/AddProduct/utils.js